/**
 * Spinner - Neumorphic loading indicator
 */

import { useTheme } from '../../lib/design-system';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  color?: 'primary' | 'white' | 'muted';
  className?: string;
}

const sizes = {
  sm: 'h-4 w-4 border-2',
  md: 'h-8 w-8 border-2',
  lg: 'h-12 w-12 border-3',
};

export default function Spinner({ size = 'lg', color = 'primary', className = '' }: SpinnerProps) {
  const { theme } = useTheme();

  const getColor = () => {
    switch (color) {
      case 'white':
        return 'white';
      case 'muted':
        return theme.textMuted;
      default:
        return theme.primary;
    }
  };

  return (
    <div
      className={`animate-spin rounded-full ${sizes[size]} ${className}`}
      style={{
        borderColor: `${getColor()}30`,
        borderTopColor: getColor(),
      }}
      role="status"
      aria-label="Laden..."
    >
      <span className="sr-only">Laden...</span>
    </div>
  );
}

// Wrapper component for centered loading state
export function LoadingState({ message }: { message?: string }) {
  const { theme } = useTheme();

  return (
    <div className="flex flex-col items-center justify-center py-12">
      <Spinner size="lg" />
      {message && (
        <p className="mt-4 text-sm" style={{ color: theme.textMuted }}>
          {message}
        </p>
      )}
    </div>
  );
}
